var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRightF = function SvgArrowRightF(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.629 2 9 9.5-9 9.5",
    stroke: "#DC4405",
    strokeWidth: 3
  })));
};
export default SvgArrowRightF;